var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid px-0 root-layout"},[_c('Sidebar'),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"dashboard-view"},[_c('div',{},[_c('router-view')],1)])]),_c('router-view',{attrs:{"name":"modals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }